<!-- Header -->
<div *ngIf="hasHeader" class="col-sm-12 header border-bottom">
  <div class="row no-margin">
    <div class="col-sm-8 title">previous messages</div>
    <div class="col-sm-4 btn-holder">
      <app-table-search (search)="searchTerm$.next($event)" [hideClearFilterBtn]="true"> </app-table-search>
    </div>
  </div>
</div>

<app-empty-table *ngIf="!messages?.length" [type]="tableType">
  <p><a (click)="onOpenInquiry()">Create an inquiry</a> first to be able to message this guest.</p>
</app-empty-table>

<div class="messages-box-holder" [ngClass]="{ 'form-visible': isMessageFormVisible }" *ngIf="messages?.length">
  <app-message-list-item
    #msg
    *ngFor="let message of filteredMessages"
    [attr.id]="message.messageId"
    [message]="message"
    [hasMove]="hasMove"
    [inquiry]="inquiry"
    (editDraft)="onEditDraft($event)"
    (aiGenerate)="onAIGenerate($event)"
  ></app-message-list-item>
</div>

<button
  (click)="openMessageForm()"
  *ngIf="!isMessageFormVisible && inquiry && !(1 | isReadonlyRole)"
  matTooltip="Reply"
  matTooltipClass="text-center"
  matTooltipPosition="left"
  class="btn-success btn-reply"
  type="button"
>
  <i class="fal fa-envelope"></i>
</button>

<ng-template [ngTemplateOutlet]="messageFormTmpl" *ngIf="isMessageFormVisible && !isMessageFormPopup"></ng-template>

<ng-template #messageFormTmpl>
  <app-inquiry-message-form
    #editor
    [inquiry]="inquiry"
    [guest]="guest"
    [draftMessage]="draftMessage"
    (close)="closeMessageForm()"
    (popup)="onPopup()"
    cdkDrag
    [cdkDragDisabled]="!isMessageFormPopup"
    [isPopup]="isMessageFormPopup"
  >
  </app-inquiry-message-form>
</ng-template>
